export const SUB_TABS = [
  { id: 'index1',            label: 'Index 1',                  hdr: '#4472C4' },
  { id: 'index2',            label: 'Index 2',                  hdr: '#4472C4' },
  { id: 'presently',         label: 'Attendance',               hdr: '#375623' },
  { id: 'daily_schedule',    label: 'Daily Schedule Work',      hdr: '#7B3F00' },
  { id: 'daily_work',        label: 'Daily Work',               hdr: '#1F3864' },
  { id: 'work_problem',      label: 'Work Problem',             hdr: '#8DB4E2', hdrFg: '#000' },
  { id: 'suggestion',        label: 'Suggestion',               hdr: '#8DB4E2', hdrFg: '#000' },
  { id: 'company_dev',       label: 'Company Development Idea', hdr: '#8DB4E2', hdrFg: '#000' },
  { id: 'cost_cutting',      label: 'Cost Cutting',             hdr: '#8DB4E2', hdrFg: '#000' },
  { id: 'senior_suggestion', label: 'Senior Suggestion',        hdr: '#8DB4E2', hdrFg: '#000' },
];

export const INDEX_CATEGORIES = [
  '','RECRUITMENT','TRAINING','HIERARCHY','BOOK','PPT','DEPARTMENT SETUP','PENDRIVE',
  'DK WINNER SYSTEM','SOP','CIRCULAR','DAILY SCHEDULE & WORK','DAILY WORK',
  'WORK PROBLEM','SUGGESTION','DEVELOPMENT IDEAS','COST CUTTING','SENIOR SUGGESTION',
  'ISSUES OR SOLUTIONS','PENALTY','DEPARTMENT WORK','DEPARTMENT DAILY REPORTS',
  'DEPARTMENT WEEKLY REPORTS','DEPARTMENT MONTHLY REPORTS','CTC','DEPARTMENT SKILL',
  'DEPARTMENT KNOWLEDGE','BEHAVIOUR','RESPONSIBILITY','ISSUE HANDLING',
];

export const MONTH_COLS = [
  'Apr-25','May-25','Jun-25','Jul-25','Aug-25','Sep-25','Oct-25','Nov-25','Dec-25','Jan-26','Feb-26','Mar-26',
  'Apr-26','May-26','Jun-26','Jul-26','Aug-26','Sep-26','Oct-26','Nov-26','Dec-26','Jan-27','Feb-27','Mar-27',
];
export const INDEX1_MONTH_COLS = MONTH_COLS; // All 24 months Apr-25 → Mar-27
export const STATUS_OPTS  = ['','INPROCESS','DONE','HOLD','CANCEL'];
export const NO_OPTS      = ['','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','25','30','35','40','44','50'];
export const REMARK_OPTS  = ['','OK','IN WORKING','INWORKING','WORKING','WORKING ON IT','DONE','INPROCESS','PENDING','HOLD','N/A','NIL','FOLLOW UP','REVIEWED','COMPLETED','APPROVED'];
export const PRIORITY_OPTS = ['','1','2','3','4','5','6','7','8','9','10'];
export const DAYS = Array.from({length:31},(_,i)=>String(i+1));
export const ATTEND_OPTS  = ['','P','A','W','WO','PL','H','HO','U'];
export const TIME_SLOTS   = ['09:00 - 10:00','10:00 - 11:00','11:00 - 12:00','12:00 - 01:00','01:00 - 02:00','02:00 - 03:00','03:00 - 04:00','04:00 - 05:00','05:00 - 06:00','06:00 - 07:00','07:00 - 08:00','08:00 - 09:00'];

export const STATUS_BG = { DONE:'#00B050', INPROCESS:'#FFFF00', CANCEL:'#FF0000', HOLD:'#BDD7EE' };
export const STATUS_FG = { DONE:'#FFFFFF', INPROCESS:'#000000', CANCEL:'#FFFFFF', HOLD:'#1F4E79' };
export const ATTEND_BG = { P:'#92D050', A:'#FF6666', WO:'#BDD7EE', H:'#FFF2CC', HO:'#FFD700', PL:'#EBE9F4', W:'#BDD7EE', U:'#FCE4D6' };

export const COLS = {
  index1: [
    {k:'srNo',l:'SR.NO.',w:55,t:'text'},
    {k:'particular',l:'PARTICULAR',w:240,t:'text'},
    {k:'person',l:'PERSON',w:150,t:'text'},{k:'status',l:'STATUS',w:110,t:'sel',o:STATUS_OPTS},
    {k:'no',l:'NO',w:60,t:'sel',o:NO_OPTS},{k:'remark',l:'REMARK',w:160,t:'sel',o:REMARK_OPTS},
    ...INDEX1_MONTH_COLS.map(m=>({k:`ms_${m}`,l:m,w:75,t:'sel',o:STATUS_OPTS,msKey:m})),
  ],
  index2: [
    {k:'srNo',l:'SR.NO.',w:55,t:'text'},
    {k:'particular',l:'PARTICULAR',w:240,t:'text'},
    {k:'person',l:'PERSON',w:150,t:'text'},{k:'status',l:'STATUS',w:110,t:'sel',o:STATUS_OPTS},
    {k:'no',l:'NO',w:60,t:'sel',o:NO_OPTS},{k:'remark',l:'REMARK',w:160,t:'sel',o:REMARK_OPTS},
    ...INDEX1_MONTH_COLS.map(m=>({k:`ms_${m}`,l:m,w:75,t:'sel',o:STATUS_OPTS,msKey:m})),
    {k:'ps_daily',l:'DAILY',w:80,t:'sel',o:STATUS_OPTS,psKey:'daily'},
    {k:'ps_weekly',l:'WEEKLY',w:80,t:'sel',o:STATUS_OPTS,psKey:'weekly'},
    {k:'ps_monthly',l:'MONTHLY',w:80,t:'sel',o:STATUS_OPTS,psKey:'monthly'},
    {k:'ps_yearly',l:'YEARLY',w:80,t:'sel',o:STATUS_OPTS,psKey:'yearly'},
  ],
  presently: [
    {k:'no',l:'NO',w:45,t:'text'},{k:'employeeId',l:'EMPLOYEE ID',w:140,t:'text'},
    {k:'name',l:'NAME',w:160,t:'text'},{k:'month',l:'MONTH',w:110,t:'month'},
    ...DAYS.map(d=>({k:`day_${d}`,l:d,w:38,t:'sel',o:ATTEND_OPTS,dayKey:d})),
  ],
  daily_schedule: [
    {k:'date',l:'DATE',w:120,t:'date'},{k:'timeSlot',l:'TIME',w:140,t:'sel',o:TIME_SLOTS},
    {k:'dailySchedule',l:'DAILY SCHEDULE',w:250,t:'text'},
    {k:'dailyWork',l:'DAILY WORK',w:350,t:'text'},
  ],
  daily_work: [
    {k:'srNo',l:'SR.NO.',w:55,t:'text'},{k:'date',l:'DATE',w:100,t:'text'},
    {k:'workDetails',l:'WORK DETAILS',w:280,t:'text'},{k:'amount',l:'AMOUNT',w:90,t:'text'},
    {k:'project',l:'PROJECT',w:130,t:'text'},{k:'department',l:'DEPARTMENT',w:120,t:'text'},
    {k:'person',l:'PERSON',w:130,t:'text'},{k:'contactPerson',l:'CONTACT PERSON',w:130,t:'text'},
    {k:'priority',l:'PRIORITY',w:80,t:'sel',o:PRIORITY_OPTS},
    {k:'status',l:'STATUS',w:110,t:'sel',o:STATUS_OPTS},{k:'no',l:'NO.',w:50,t:'text'},
    {k:'remark',l:'REMARK',w:150,t:'text'},
  ],
};
['work_problem','suggestion','company_dev','cost_cutting','senior_suggestion'].forEach(k=>{ COLS[k]=COLS.daily_work; });

export const blankRowData = (tab, personName, dept) => {
  if (tab==='index1') return {srNo:'',particular:'',person:personName,status:'',no:'',remark:'',monthlyStatus:{}};
  if (tab==='index2') return {srNo:'',particular:'',person:personName,status:'',no:'',remark:'',monthlyStatus:{},periodStatus:{}};
  if (tab==='presently') return {no:'',employeeId:'',name:personName,month:new Date().toISOString().slice(0,7),dayEntries:{}};
  if (tab==='daily_schedule') return {date:'',timeSlot:'',dailySchedule:'',dailyWork:''};
  return {srNo:'',date:'',workDetails:'',amount:'',project:'',department:dept,person:personName,contactPerson:'',priority:'',status:'',no:'',remark:''};
};

export const getCellVal = (rd, col) => {
  if (col.msKey) return (rd.monthlyStatus||{})[col.msKey]||'';
  if (col.psKey) return (rd.periodStatus||{})[col.psKey]||'';
  if (col.dayKey) return (rd.dayEntries||{})[col.dayKey]||'';
  return rd[col.k]??'';
};

export const setCellVal = (rd, col, val) => {
  if (col.msKey) return {...rd, monthlyStatus:{...(rd.monthlyStatus||{}), [col.msKey]:val}};
  if (col.psKey) return {...rd, periodStatus:{...(rd.periodStatus||{}), [col.psKey]:val}};
  if (col.dayKey) return {...rd, dayEntries:{...(rd.dayEntries||{}), [col.dayKey]:val}};
  return {...rd, [col.k]:val};
};

export const rowBg = (rd) => {
  const s = (rd.status||'').trim().toUpperCase();
  return STATUS_BG[s]||'';
};
